import { ComponentProps } from 'react';
import SvgIcon from '@mui/material/SvgIcon';

type MuiIconProps = ComponentProps<typeof SvgIcon>;

export const CheckboxCheckedIcon = (props: MuiIconProps) => {
  return (
    <SvgIcon {...props}>
      <path d="M8,0C12.4,0,16,3.6,16,8s-3.6,8-8,8S0,12.4,0,8,3.6,0,8,0ZM11,5.5c-.4-.4-1-.4-1.4,0l-2.8,2.8-.8-.8h0c-.4-.4-1-.4-1.3,0-.4.4-.4.9,0,1.3h0c0,0,1.5,1.6,1.5,1.6h0c.4.4,1,.4,1.3,0l3.5-3.5c.4-.4.4-1,0-1.4Z" />
    </SvgIcon>
  );
};
